// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__27NMe","offline":"style_offline__3Th2S","offlineTextInfo":"style_offlineTextInfo__3XLpX"};